<template>
  <el-dialog :title="getLogType" :visible="visible" width="1000px" top="5vh" :close-on-click-modal="false" class="page-dialog" append-to-body @close="handleClose">
    <div style="padding: 0 10px">
      <el-form :inline="true" :model="searchForm" size="mini" label-width="72px" style="margin-bottom: 10px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="会员ID">
              <el-input v-model="searchForm.uid" placeholder="请输入会员ID" clearable style="width: 180px" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抽奖时间">
              <DateTimeRangePicker v-model="searchForm.timeRange" size="mini" style="width: 360px" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button type="primary" size="mini" @click="handleSearch">筛选</el-button>
              <el-button size="mini" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table :data="logs" border stripe size="small" highlight-current-row v-loading="loading" style="width: 100%">
        <el-table-column :resizable="false" prop="order" label="记录ID" min-width="160" />
        <el-table-column :resizable="false" prop="uid" label="会员ID" width="120" align="center" />
        <el-table-column :resizable="false" label="奖品信息" width="120" align="center">
          <template slot-scope="scope">{{ formatPrize(scope.row) }}</template>
        </el-table-column>
        <el-table-column :resizable="false" label="抽奖时间" width="200">
          <template slot-scope="scope">{{ formatTimestamp(scope.row.created_at) }}</template>
        </el-table-column>
      </el-table>

      <div style="text-align: right; margin-top: 15px">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="[10, 20, 30, 50]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { getSpinLuckLog, getSignInLog, getRedEnvelopeRainLog } from '@/api/operation/activity'
import DateTimeRangePicker from '@/components/DateTimeRangePicker'
import { centsToYuan } from '@/utils/amount'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'
import { reactive, ref, watch, computed } from 'vue'
import { ACT_TYPE_OPTIONS } from '../const'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  actId: {
    type: [String, Number],
    default: null,
  },
  actType: {
    type: [String, Number],
    default: null,
  },
})

const emit = defineEmits(['update:visible'])

const getLogType = computed(() => {
  return ACT_TYPE_OPTIONS.find(opt => opt.value === props.actType)?.label + '记录' || '抽奖记录'
})

const getLogApi = () => {
  if (props.actType == 2) {
    return getRedEnvelopeRainLog
  }

  if (props.actType == 4) {
    return getSignInLog
  }
  return getSpinLuckLog
}

const loading = ref(false)
const logs = ref([])
const total = ref(0)
const page = ref(1)
const pageSize = ref(10)

const searchForm = reactive({
  uid: '',
  timeRange: [],
})

function formatPrize(row) {
  if (props.actType == 4) {
    return centsToYuan(row.gold)
  }
  return centsToYuan(row.reward)
}

async function loadLogs() {
  if (props.actId == null || props.actId === '') return
  loading.value = true
  try {
    const params = {
      act_id: String(props.actId),
      page: page.value,
      page_size: pageSize.value,
    }
    if (searchForm.uid !== '' && searchForm.uid != null) {
      params.uid = Number(searchForm.uid)
    }
    if (Array.isArray(searchForm.timeRange) && searchForm.timeRange.length === 2) {
      const [start, end] = searchForm.timeRange
      const startAt = toUnixSeconds(start)
      const endAt = toUnixSeconds(end)
      if (startAt) params.start_at = startAt
      if (endAt) params.end_at = endAt
    }
    const api = getLogApi()
    const res = await api(params)
    const data = (res && res.data) || res
    const rawList = (data && data.list) || []
    const rawTotal = (data && data.total) != null ? data.total : 0
    logs.value = Array.isArray(rawList) ? rawList : []
    total.value = rawTotal
  } catch (e) {
    logs.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

function handleSearch() {
  page.value = 1
  loadLogs()
}

function handleReset() {
  searchForm.uid = ''
  searchForm.timeRange = []
  page.value = 1
  loadLogs()
}

function handleSizeChange(size) {
  pageSize.value = size
  page.value = 1
  loadLogs()
}

function handleCurrentChange(p) {
  page.value = p
  loadLogs()
}

function handleClose() {
  emit('update:visible', false)
}

watch(
  () => [props.visible, props.actId],
  ([visible]) => {
    if (!visible) return
    page.value = 1
    loadLogs()
  }
)
</script>
